import { useEffect, useState } from 'react';

import { useBrowserStorage } from 'hooks/UseBrowserStorage';

import type { TLastSearch } from 'components/PageWrappers/SharedComponents/LastSearchCard/types';

enum LAST_SEARCH {
  KEY = 'LastSearchData',
}

function useLastSearch() {
  const { getLocalStorageItem, setLocalStorageItem, removeLocalStorageItem } =
    useBrowserStorage();
  const [lastSearchData, setLastSearchData] = useState<TLastSearch>();

  function setLastSearch(terms: string, searchLink: string) {
    setLocalStorageItem(LAST_SEARCH.KEY, {
      terms,
      expiryDate: (Date.now() + 12096e5).toString(),
      searchLink,
    });
  }

  function getLastSearch() {
    const searchTerms: TLastSearch = getLocalStorageItem(LAST_SEARCH.KEY);

    return searchTerms;
  }

  function removeLastSearch() {
    removeLocalStorageItem(LAST_SEARCH.KEY);
  }

  useEffect(() => {
    const lastSearchData = getLastSearch();
    if (lastSearchData) {
      if (parseInt(lastSearchData.expiryDate) < Date.now()) {
        removeLastSearch();
      } else setLastSearchData(lastSearchData);
    }
  }, []);

  return {
    getLastSearch,
    setLastSearch,
    removeLastSearch,
    lastSearchData,
  };
}

export { useLastSearch };
